import { render, staticRenderFns } from "./borrowInvoice.vue?vue&type=template&id=b0b32cba&scoped=true&"
import script from "./borrowInvoice.vue?vue&type=script&lang=js&"
export * from "./borrowInvoice.vue?vue&type=script&lang=js&"
import style0 from "./borrowInvoice.vue?vue&type=style&index=0&id=b0b32cba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b32cba",
  null
  
)

export default component.exports